import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as h } from "vue";
const f = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "bba7d7b6-d343-4632-bccc-72183926284c" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#bba7d7b6-d343-4632-bccc-72183926284c)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "m0 167 256-32 256 32v178l-256 32L0 345Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 345h512v167H0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h512v167H0Z"
}, null, -1), b = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ a({
  __name: "ru-ko",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=ru-ko-68b20f95.js.map
